export default function CalendarPage() {
  return (
    <div>
      <h1 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#1a1c2c', marginBottom: '1rem' }}>
        📅 Calendario
      </h1>
      <p style={{ color: '#888' }}>Calendario escolar pendiente de implementación.</p>
    </div>
  );
}
